/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import {
  getAllModelSeriesDeeplinks,
  GetAllModelSeriesDeeplinks$Params
} from '../fn/deeplinks/get-all-model-series-deeplinks';
import {
  getDeeplinksByBaumusterAndModelYear,
  GetDeeplinksByBaumusterAndModelYear$Params
} from '../fn/deeplinks/get-deeplinks-by-baumuster-and-model-year';
import {
  getDeeplinksByModelSeries,
  GetDeeplinksByModelSeries$Params
} from '../fn/deeplinks/get-deeplinks-by-model-series';
import { getDeeplinksByTypeId, GetDeeplinksByTypeId$Params } from '../fn/deeplinks/get-deeplinks-by-type-id';
import { DeeplinkDto } from '../models/deeplink-dto';
import { ProductModelSeriesDeeplinksDto } from '../models/product-model-series-deeplinks-dto';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class DeeplinksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeeplinksByTypeId()` */
  static readonly GetDeeplinksByTypeIdPath = '/deeplinks/{market}/{language}/type-id/{typeId}';

  /**
   * Get Deeplinks by Type ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeeplinksByTypeId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByTypeId$Response(
    params: GetDeeplinksByTypeId$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      [key: string]: DeeplinkDto;
    }>
  > {
    return getDeeplinksByTypeId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Deeplinks by Type ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeeplinksByTypeId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByTypeId(
    params: GetDeeplinksByTypeId$Params,
    context?: HttpContext
  ): Observable<{
    [key: string]: DeeplinkDto;
  }> {
    return this.getDeeplinksByTypeId$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<{
            [key: string]: DeeplinkDto;
          }>
        ): {
          [key: string]: DeeplinkDto;
        } => r.body
      )
    );
  }

  /** Path part for operation `getDeeplinksByModelSeries()` */
  static readonly GetDeeplinksByModelSeriesPath = '/deeplinks/{market}/{language}/model-series/{modelSeries}';

  /**
   * Get Deeplinks by Model Series.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeeplinksByModelSeries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByModelSeries$Response(
    params: GetDeeplinksByModelSeries$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      [key: string]: DeeplinkDto;
    }>
  > {
    return getDeeplinksByModelSeries(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Deeplinks by Model Series.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeeplinksByModelSeries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByModelSeries(
    params: GetDeeplinksByModelSeries$Params,
    context?: HttpContext
  ): Observable<{
    [key: string]: DeeplinkDto;
  }> {
    return this.getDeeplinksByModelSeries$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<{
            [key: string]: DeeplinkDto;
          }>
        ): {
          [key: string]: DeeplinkDto;
        } => r.body
      )
    );
  }

  /** Path part for operation `getAllModelSeriesDeeplinks()` */
  static readonly GetAllModelSeriesDeeplinksPath = '/deeplinks/{market}/{language}/model-series';

  /**
   * Get all Model Series Deeplinks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllModelSeriesDeeplinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllModelSeriesDeeplinks$Response(
    params: GetAllModelSeriesDeeplinks$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      [key: string]: {
        [key: string]: ProductModelSeriesDeeplinksDto;
      };
    }>
  > {
    return getAllModelSeriesDeeplinks(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all Model Series Deeplinks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllModelSeriesDeeplinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllModelSeriesDeeplinks(
    params: GetAllModelSeriesDeeplinks$Params,
    context?: HttpContext
  ): Observable<{
    [key: string]: {
      [key: string]: ProductModelSeriesDeeplinksDto;
    };
  }> {
    return this.getAllModelSeriesDeeplinks$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<{
            [key: string]: {
              [key: string]: ProductModelSeriesDeeplinksDto;
            };
          }>
        ): {
          [key: string]: {
            [key: string]: ProductModelSeriesDeeplinksDto;
          };
        } => r.body
      )
    );
  }

  /** Path part for operation `getDeeplinksByBaumusterAndModelYear()` */
  static readonly GetDeeplinksByBaumusterAndModelYearPath =
    '/deeplinks/{market}/{language}/baumuster/{baumuster}/model-year/{modelYear}';

  /**
   * Get Deeplinks by Baumuster, Model Year, Change Year and National Sales Type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeeplinksByBaumusterAndModelYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByBaumusterAndModelYear$Response(
    params: GetDeeplinksByBaumusterAndModelYear$Params,
    context?: HttpContext
  ): Observable<
    StrictHttpResponse<{
      [key: string]: DeeplinkDto;
    }>
  > {
    return getDeeplinksByBaumusterAndModelYear(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Deeplinks by Baumuster, Model Year, Change Year and National Sales Type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeeplinksByBaumusterAndModelYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeeplinksByBaumusterAndModelYear(
    params: GetDeeplinksByBaumusterAndModelYear$Params,
    context?: HttpContext
  ): Observable<{
    [key: string]: DeeplinkDto;
  }> {
    return this.getDeeplinksByBaumusterAndModelYear$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<{
            [key: string]: DeeplinkDto;
          }>
        ): {
          [key: string]: DeeplinkDto;
        } => r.body
      )
    );
  }
}
